export const SaveImgToAPIUrl = "/myapi/PicsAPIViews"
export const API_URL = "/myapi/APIViews"
//"http://localhost:8000/api/posts/"; PicsAPIViews
export const URL = "http://localhost:8000/";
export const ProjectCategoryRecordsUrl="/myapi/ProjectCategoryAndPicsView";
